import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    buttons: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    secondaryActionButton: {
      paddingRight: theme.spacing(1),
    },
  });
});
